import axios from "axios";
import { useEffect, useState } from "react";
import { BsX } from "react-icons/bs";
import Config from "../../Config";
import {
  bottomSheetDragHandleVisualStyle,
  useBottomSheetDrag,
} from "../../hooks/useBottomSheetDrag";
import { useWindowDimensions } from "../../utils";
import { validatePhone } from "../../utilities/validatePhone";
import { ModalDefault } from "../containers/ModalDefault";
import { FormPhoneInput } from "../inputs/FormTextInput/FormPhoneInput";
import ModalSimple from "./ModalSimple";
import {
  HelpCloseButton,
  HelpField,
  HelpFieldsRow,
  HelpForm,
  HelpHandle,
  HelpHeader,
  HelpHeaderCopy,
  HelpInput,
  HelpPhoneWrap,
  HelpSheet,
  HelpSubmit,
  HelpSubtitle,
  HelpTextarea,
  HelpTitle,
} from "./ModalSendMail.styles";
import { useI18n } from "../../i18n/I18nProvider";

const ModalSendMail = ({
  modalOpen,
  setModalOpen,
  email,
  phone,
  message,
  theme,
}) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();
  const isMobile = screenWidth <= 640;
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [emailValue, setEmailValue] = useState();
  const [phoneValue, setPhoneValue] = useState();
  const [messageValue, setMessageValue] = useState(message || "");
  const [modalSimpleOpen, setModalSimpleOpen] = useState(false);
  const [modalSimpleText, setModalSimpleText] = useState("");
  const [modalSimpleType, setModalSimpleType] = useState("");

  const closeModal = () => setModalOpen(false);

  const { dragHandleProps, sheetMotionStyle, resetDrag } = useBottomSheetDrag({
    enabled: isMobile,
    onClose: closeModal,
  });

  useEffect(() => {
    setEmailValue(email);
    setPhoneValue(phone);
    setMessageValue(message || "");
  }, [email, phone, message]);

  useEffect(() => {
    if (!modalOpen) {
      resetDrag();
    }
  }, [modalOpen, resetDrag]);

  const canSubmit =
    !isSaveButtonDisabled && Boolean(emailValue && phoneValue && messageValue);

  const handleSave = (event) => {
    event.preventDefault();
    if (!canSubmit) {
      return;
    }

    const phoneValidation = validatePhone(phoneValue);
    if (!phoneValidation.valid) {
      setModalSimpleText(
        t(phoneValidation.error ||
          "Введите корректный номер телефона (10–15 цифр)"),
      );
      setModalSimpleType("error");
      setModalSimpleOpen(true);
      return;
    }

    const formData = {
      theme: theme || t("Проблема в SPEAKID"),
      question: messageValue,
      email: emailValue,
      phone: phoneValue,
    };

    axios
      .post(Config.BACKEND_ADDR + "/support/new_request", formData)
      .then((response) => {
        if (response.status === 200) {
          setModalSimpleText(
            t("Служба поддержки свяжется с вами в ближайшее время."),
          );
          setModalSimpleType("success");
          setModalSimpleOpen(true);
        } else {
          setModalSimpleText(t("Ошибка при обработке запроса сервером"));
          setModalSimpleType("error");
          setModalSimpleOpen(true);
        }
      })
      .catch(() => {
        setModalSimpleText(t("Ошибка при отправке запроса на сервер"));
        setModalSimpleType("error");
        setModalSimpleOpen(true);
      });
    setModalSimpleOpen(true);
    setIsSaveButtonDisabled(true);
  };

  if (modalSimpleOpen) {
    return (
      <ModalSimple
        isOpen={modalSimpleOpen}
        onClose={() => {
          setModalSimpleOpen(false);
          setModalOpen(false);
        }}
        h2={modalSimpleType === "success" ? t("Обращение создано!") : t("Ошибка")}
        p={modalSimpleText}
        type={modalSimpleType}
      />
    );
  }

  return (
    <ModalDefault
      onRequestClose={closeModal}
      isOpen={modalOpen}
      centerAlways={!isMobile}
      mobileBottomSheet={isMobile}
    >
      <HelpSheet style={isMobile ? sheetMotionStyle : undefined}>
        {isMobile && (
          <div {...dragHandleProps}>
            <HelpHandle style={bottomSheetDragHandleVisualStyle} />
          </div>
        )}

        <HelpHeader>
          <HelpHeaderCopy>
            <HelpTitle>{t("Помощь")}</HelpTitle>
            <HelpSubtitle>{t("Ответим в течение рабочего дня")}</HelpSubtitle>
          </HelpHeaderCopy>
          <HelpCloseButton type="button" onClick={closeModal} aria-label={t("Закрыть")}>
            <BsX size={22} />
          </HelpCloseButton>
        </HelpHeader>

        <HelpForm onSubmit={handleSave}>
          <HelpFieldsRow>
            <HelpPhoneWrap>
              <FormPhoneInput
                placeholder="+7 (___) ___ __ __"
                value={phoneValue}
                title={t("Телефон")}
                onChange={(e) => {
                  setIsSaveButtonDisabled(false);
                  setPhoneValue(e.target.value);
                }}
                width="100%"
              />
            </HelpPhoneWrap>
            <HelpField>
              Email
              <HelpInput
                type="email"
                placeholder={t("Введите email")}
                value={emailValue || ""}
                onChange={(e) => {
                  setIsSaveButtonDisabled(false);
                  setEmailValue(e.target.value);
                }}
              />
            </HelpField>
          </HelpFieldsRow>

          <HelpField>
            {t("Сообщение")}
            <HelpTextarea
              placeholder={t("Введите сообщение")}
              value={messageValue}
              onChange={(e) => {
                setIsSaveButtonDisabled(false);
                setMessageValue(e.target.value);
              }}
            />
          </HelpField>

          <HelpSubmit type="submit" disabled={!canSubmit}>
            {t("Отправить")}
          </HelpSubmit>
        </HelpForm>
      </HelpSheet>
    </ModalDefault>
  );
};

export default ModalSendMail;
